module.exports = __webpack_public_path__ + "static/media/logo_checkout.de060c40.svg";